<script>
import LocationCard from "./LocationCard.svelte"
import { fade, slide } from "svelte/transition"

//props
export let locations = []
export let regions = []

//vars
let current = null

//fns
const toggleCurrent = id =>
	current = current !== id
		? id
		: null

const toAccordion = ( regions, locations ) =>
	//group by regions
	regions.reduce( ( acc, region ) => {

		const accordionItem = {
			header: { ...region },
			locations: locations.filter( l => l.state.id === region.id )
		}

		if ( accordionItem.locations.length > 0 ) {
			acc.push( accordionItem )
		}

		return acc
	}, [] )

// reactive
$: accordion = toAccordion( regions, locations )
$: isExpanded = id => current === id
</script>

<div class="location-list" transition:fade>

	{#if locations.length === 0 }
		<div class="location-list__header">
			<span>No locations found</span>
		</div>
	{:else}

		<div class="location-list__header">
			<span>Or find by region:</span>
		</div>

		<div class="location-list__accordion accordion">
			{#each accordion as acc}
				<div class="accordion-item">

					<div class="accordion-header">
						<div class="accordion-button" on:click={() => toggleCurrent(acc.header.id)} class:expanded={isExpanded(acc.header.id)}>
							<div class="accordion-button__title">{acc.header.title}</div>
							<div class="accordion-button__toggle">
								<svg xmlns="http://www.w3.org/2000/svg" width="14.21" height="8.36" viewBox="0 0 14.21 8.36">
									<path class="downiconpath" fill="#6a6a6a" d="M.07,1.88A1,1,0,0,1,1,.93a.92.92,0,0,1,.68.29l5.46,5.7,5.46-5.7a1,1,0,0,1,1.36,0,1,1,0,0,1,0,1.33L7.88,9A1,1,0,0,1,6.51,9l0,0L.34,2.56A.94.94,0,0,1,.07,1.88Z" transform="translate(-0.07 -0.93)"></path>
								</svg>
							</div>
						</div>
					</div>

					{#if isExpanded( acc.header.id )}
						<div class="accordion-collapse" transition:slide|local>
							<div class="accordion-body">
								{#each acc.locations as location}
									<LocationCard {location}/>
								{/each}
							</div>
						</div>
					{/if}
				</div>
			{/each}
		</div>
	{/if}
</div>
